import Component from './js/component.vue';
import './css/index.css';

export default Component